import { useVisualComponentsContext } from '../../contexts/visualComponents';
import { useQueryStateContext } from '../../contexts';
import { useRemoveCriteria, useResetCriteriaErrors } from '../../hooks/criteria';

export const RemoveButton = () => {
  const { RemoveCriteriaButton } = useVisualComponentsContext();
  const { isReadOnly = false } = useQueryStateContext();
  const removeCriteria = useRemoveCriteria();
  const resetCriteriaErrors = useResetCriteriaErrors();

  return (
    <RemoveCriteriaButton
      isDisabled={isReadOnly}
      onClick={() => {
        removeCriteria();
        resetCriteriaErrors();
      }}
    />
  );
};
